import React from 'react';
import { SharedContent } from '../../services/shareService';
import PlayerStatSheetPage from '../Seasons/PlayerStatSheetPage';

interface SharedPlayerStatSheetProps {
  shareData: SharedContent;
}

const SharedPlayerStatSheet: React.FC<SharedPlayerStatSheetProps> = ({ shareData }) => {
  if (!shareData.clientId || !shareData.seasonId || !shareData.playerSeasonId) {
    return (
      <div className="p-8 text-center text-red-600">
        This player share link is missing required information.
      </div>
    );
  }

  return (
    <PlayerStatSheetPage
      readOnly
      shareContext={{
        clientId: shareData.clientId,
        seasonId: shareData.seasonId,
        playerSeasonId: shareData.playerSeasonId,
      }}
    />
  );
};

export default SharedPlayerStatSheet;
